module.exports = __webpack_public_path__ + "img/event.c8df3304.png";